// StudentController.js
import BaseController from "src/controller/BaseController.js";
import ApiUrls from "src/routes/api";
import RestApiClient from "src/utils/RestApiClient";

const api = new RestApiClient();

class Student extends BaseController {
  _list = ApiUrls.student.index;

  _get = ApiUrls.student.get;

  _post = ApiUrls.student.create;

  _getDetails = ApiUrls.student.details;

  _getEnrollments = ApiUrls.student.enrollments;

  _createAssessment = ApiUrls.student.createAssessment;

  async listByTeacher(id, query = "") {
    return new Promise((resolve, reject) => {
      api
        .get(ApiUrls.student.listByTeacher(id) + query)
        .then((res) => {
          if (res.result) {
            resolve(res.data);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }

  async getDetails(id) {
    try {
      const response = await api.get(ApiUrls.student.details(id));
      return response.data;
    } catch (error) {
      console.error(`Error fetching details for student with id ${id}:`, error);
      throw error;
    }
  }

  async getEnrollments(id) {
    try {
      const response = await api.get(ApiUrls.student.enrollments(id));
      return response.data;
    } catch (error) {
      console.error(
        `Error fetching enrollments for student with id ${id}:`,
        error
      );
      throw error;
    }
  }

  async getAssessments(id) {
    try {
      const response = await api.get(ApiUrls.student.assessments(id));
      return response.data;
    } catch (error) {
      console.error(
        `Error fetching enrollments for student with id ${id}:`,
        error
      );
      throw error;
    }
  }

  async getLearningPlans(id) {
    try {
      const response = await api.get(ApiUrls.student.learningPlans(id));
      return response.data;
    } catch (error) {
      console.error(
        `Error fetching enrollments for student with id ${id}:`,
        error
      );
    }
  }

  async createQuestionToLearningPlan(id, questionData) {
    try {
      const response = await api.post(
        ApiUrls.learningPlan.createQuestion(id),
        questionData
      );
      return response.data;
    } catch (error) {
      console.error(
        `Error adding question to learning plan with id ${id}:`,
        error
      );
      throw error;
    }
  }

  async createAssessment(assessmentData) {
    try {
      const response = await api.post(
        ApiUrls.student.createAssessment,
        assessmentData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating assessment:", error);

      throw error;
    }
  }

  async getAssessmentReports(student_id, subject_code) {
    return new Promise((resolve, reject) => {
      api
        .get(
          ApiUrls.student.assessmentsReport(
            student_id,
            encodeURIComponent(subject_code)
          )
        )
        .then((res) => {
          if (res.result) {
            resolve(res.data);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export default new Student();
